import { type CSSProperties, type ReactNode } from 'react'
import styles from './RowActions.module.css'

type RowActionsProps = {
  children: ReactNode
  className?: string
  mobileStack?: boolean
  style?: CSSProperties
}

export const RowActions = ({ children, className, mobileStack = false, style }: RowActionsProps) => (
  <div className={[styles.actions, mobileStack ? styles.mobileStack : '', className].filter(Boolean).join(' ')} style={style}>
    {children}
  </div>
)
